var app = angular.module("alk.translations");

app.factory("alkTranslationLoader", [function () {

  function load($translateProvider) {
    //Turn this on during debugging to get console warnings when translations are missing
    $translateProvider.useMissingTranslationHandlerLog();

    $translateProvider
      .useStaticFilesLoader({
        //Put common first so that app-specific overrides for same translation string
        files: [{
          prefix: "/resources/common/",
          suffix: ".json"
        }, {
          prefix: "/resources/",
          suffix: ".json"
        }]
      })
      .registerAvailableLanguageKeys(["en_US", "es_ES", "de_DE"], {
        "en-US": "en_US",
        "es-ES": "es_ES",
        "de-DE": "de_DE",
        "en": "en_US",
        "es": "es_ES",
        "de": "de_DE"
      })
      .determinePreferredLanguage(function () {
        // if a language is not explicitely set by the user, it uses the language returned from the html "lang" attribute.  This is set on the serverside based on the Accept-Language request header.
        var lang = document.getElementsByTagName("html")[0].lang;
        return lang;
      })
      .fallbackLanguage("en_US");

    $translateProvider.useSanitizeValueStrategy("escapeParameters");

    $translateProvider.useLocalStorage();
  }

  return {
    load: load
  };

}]);



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-translations/alkTranslationLoader.js